import React from 'react'
import { useSelector } from 'react-redux'
import { I18n, Translate } from 'react-redux-i18n'
import { Notification } from '../../../../../../../common/notification'
import { valToPercent } from '../../../../../../../helpers/value'
import { selectListPDTermStructure } from '../../../../store/slice'
import s from './index.module.scss'

const ForwardLookingPDTermStructureContent = () => {
  const listPDTermStructure = useSelector(selectListPDTermStructure)
  const locale = useSelector((state) => state.i18n.locale)

  const isNoData = Object.entries(listPDTermStructure)
    .filter(([key]) => key !== 'recordId')
    .every(([, value]) => value === null || value === undefined)

  const pdList = Array.from({ length: 35 }, (_, i) => {
    const key = `pD${i + 1}Y`
    const value = listPDTermStructure[key]
    if (value === undefined || value === null) {
      console.warn(`Missing value for ${key}`)
    }
    return {
      year: `${i + 1} ${I18n.t(
        i
          ? 'forwardLookingPDTermStructure.years'
          : 'forwardLookingPDTermStructure.year',
      )}`,
      value: valToPercent(value, locale, true, true, 4),
    }
  })

  const rows = []
  for (let i = 0; i < pdList.length; i += 12) {
    rows.push(pdList.slice(i, i + 12))
  }

  if (isNoData) {
    return (
      <div style={{ height: 200 }}>
        <Notification />
      </div>
    )
  }

  return (
    <>
      <div className={s.title}>
        <Translate value="forwardLookingPDTermStructure.yearlyTermStructure" />
      </div>
      <table className={s.table}>
        <tbody>
          {rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((item, colIndex) => (
                <td key={colIndex}>
                  <div className={s.cellTitle}>{item.year}</div>
                  <div className={s.cellValue}>{item.value}</div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </>
  )
}

export default ForwardLookingPDTermStructureContent
